/**
 * @generated SignedSource<<937e829133317632044e35ad146592ad>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type TodoOverviewListItemExpireInfo_Todo$data = {
  readonly expireAt: string | null;
  readonly " $fragmentType": "TodoOverviewListItemExpireInfo_Todo";
};
export type TodoOverviewListItemExpireInfo_Todo$key = {
  readonly " $data"?: TodoOverviewListItemExpireInfo_Todo$data;
  readonly " $fragmentSpreads": FragmentRefs<"TodoOverviewListItemExpireInfo_Todo">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "TodoOverviewListItemExpireInfo_Todo",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "expireAt",
      "storageKey": null
    }
  ],
  "type": "Todo",
  "abstractKey": null
};

(node as any).hash = "46822f87b86190c2f30f43e8e8b07ff1";

export default node;
